<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 sm3 md3>
				<app-profile-menu
					:customer="$page.props.auth.customer.display_name"
					:customer_image="$page.props.auth.customer_image"
				></app-profile-menu>
			</v-flex>
			<v-flex xs12 sm9 md9>
				<v-card tile>
					<v-card-title primary-title>
						{{ $t("title.my_addresses") }}
						<v-spacer></v-spacer>
						<Link
							as="v-btn"
							color="success"
							:href="$route('shop.addresses.create')"
						>
							<v-icon left>mdi-plus</v-icon>
							{{ $t("Create") }}
						</Link>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-simple-table>
							<template v-slot:default>
								<thead>
									<tr>
										<th>
											{{ $t("label.home") }}
										</th>
										<th>{{ $t("label.house_number") }}</th>
										<th>{{ $t("label.street") }}</th>
										<th>{{ $t("label.address") }}</th>
										<th>{{ $t("label.phone_number") }}</th>
										<th>
											{{ $t("label.contact_person") }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(item, index) in items"
										:key="index"
									>
										<td>{{ item.name }}</td>
										<td>{{ item.house_number }}</td>
										<td>{{ item.street }}</td>
										<td>{{ item.address }}</td>
										<td>{{ item.phone_number }}</td>
										<td>{{ item.contact_person }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
export default {
	components: {
		Link,
	},
	props: ["data"],
	data() {
		return {
			items: this.data,
		};
	},
};
</script>